import {Injectable, EventEmitter} from '@angular/core';

import {Savable } from 'app/services/storage/savable';
import {LocalStorageService} from 'app/services/storage/local-storage.service';

interface ISidebarSettings {
    visible: boolean;
}

@Injectable()
@Savable.key('sidebarSettings')
export class SidebarSettingsService extends Savable {

    @Savable.property
    visible: boolean;

    constructor(private _localStorageService: LocalStorageService) {
        super(_localStorageService);
        this.restore();
    }

    protected restore(): ISidebarSettings {
        const restored: ISidebarSettings = super.restore();
        this.visible = restored.visible || true;
        return this;
    }
}
